// import * as React from "react";
import React, { Component } from 'react';
import { Router, Route, Switch } from "react-router-dom";
import { connect } from 'react-redux';
import "tabler-react/dist/Tabler.css";

import { history } from './utils/helpers/history';
import routes from './route';
import { PrivateRoute } from './component/Errors/PrivateRoute';
import { DefaultRoute } from './component/Errors/DefaultRoute';

class App extends Component {
  render() { 
    return (
        <Router  history={history}>
          <Switch>
          {
            routes.map((route,index) => {
            return (
              route.protected ?
                <PrivateRoute
                  key={index}
                  {...route}
                />
              :
                route.default ? <DefaultRoute
                  key={index}
                  {...route}
                />
              :
              <Route
                  key={index}
                  {...route}
                />  
            )
            })
          }
          </Switch>
        </Router>
      );
  }
}
function mapStateToProps(state) {
  const { alert, authentication: { loggedIn } } = state;
  return {
      alert,
      loggedIn
  };
}

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(App);